import { useState, useEffect } from "react";
import { Map, useMap } from "@vis.gl/react-google-maps";
import { getEventText } from "lib/utils";
import PoiMarkers from "ui/map/poi-markers";

export default function MapControl(props: { siteId; location; eventType }) {
  const map = useMap();
  const [locations, setLocations] = useState([]);
  const { siteId, location, eventType } = props;

  useEffect(() => {
    if (!map) return;
    if (
      !isNaN(location?.polygon?.latitude) &&
      !isNaN(location?.polygon?.longitude)
    ) {
      const lat = location?.polygon?.latitude;
      const lng = location?.polygon?.longitude;
      const _locations = [
        {
          key: siteId.toString(),
          name: eventType,
          location: { lat, lng },
          title: getEventText(eventType),
          type: "alertMap",
          disableInfoWindow: true,
        },
      ];
      setLocations(_locations);
      map.panTo(new google.maps.LatLng(lat, lng));
      map.setZoom(19);
    }
  }, [location, eventType, map]);

  return (
    <>
      <div className="w-full h-full rounded-3xl bg-white">
        <Map
          draggableCursor={"unset"}
          defaultZoom={4}
          defaultCenter={{ lat: 37.0902, lng: -95.7129 }}
          mapId="a060739f521f7239"
          mapTypeId={"hybrid"}
        >
          <PoiMarkers pois={locations} />
        </Map>
      </div>
    </>
  );
}
